import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import accounting from 'accounting';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title as DefaultTitle } from '../../components/Shared/TitleSuccess';

import { setOverlayPartnerVisible } from '../Widget/actions';

import { copyFor } from '../../copy/copy';
import { ActionTypes, PaymentProviders } from '../../utils/enums';

const Title = styled(DefaultTitle)`
    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }
`;

const TitleComponent = props => (
    <Title
        onClick={e => props.setOverlayPartnerVisible(true, e, false)}
        dangerouslySetInnerHTML={{
            __html: copyFor(
                'feedback',
                props.paymentProvider && props.providerSpecificInfo
                    ? 'donatedWithInfo'
                    : 'donated',
                'donation',
                undefined,
                props.paymentProvider && props.providerSpecificInfo
                    ? {
                          user: props.providerSpecificInfo,
                          paymentType: PaymentProviders.find(
                              p => p.id === props.paymentProvider
                          ).displayName,
                          amountFormated: props.amountFormated,
                          partnerName: `<span id="partnerName">${
                              props.partnerName
                          }</span>`
                      }
                    : {
                          amountFormated: props.amountFormated,
                          partnerName: `<span id="partnerName">${
                              props.partnerName
                          }</span>`
                      }
            )
        }}
    />
);

TitleComponent.propTypes = {
    amountFormated: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    paymentProvider: PropTypes.number,
    providerSpecificInfo: PropTypes.string,
    setOverlayPartnerVisible: PropTypes.func.isRequired
};

const DonationSuccess = props => (
    <TransitionContainer>
        <ConfirmationCard
            fullwidth
            peopleCount={props.peopleCount}
            thankYouText={props.thankYouText}
            titleComponent={
                <TitleComponent
                    paymentProvider={props.paymentProvider}
                    providerSpecificInfo={props.providerSpecificInfo}
                    amountFormated={props.amountFormated}
                    partnerName={props.partnerName}
                    setOverlayPartnerVisible={props.setOverlayPartnerVisible}
                />
            }
            {...props}
        />
    </TransitionContainer>
);

DonationSuccess.propTypes = {
    amountFormated: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    paymentProvider: PropTypes.number,
    peopleCount: PropTypes.string.isRequired,
    providerSpecificInfo: PropTypes.string,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    thankYouText: PropTypes.string.isRequired
};

export default connect(
    state => ({
        peopleCount:
            state.donation.completeDonation !== undefined
                ? state.donation.completeDonation.endUsersCount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : '',
        thankYouText: state.donation.successInfo.feedbackText || '',
        amountFormated: accounting.formatMoney(state.donation.selectedAmount, '$', 0),
        partnerName: state.donation.successInfo.partnerName,
        paymentProvider: state.donation.successInfo.paymentProvider || null,
        providerSpecificInfo: state.donation.successInfo.providerSpecificInfo || null
    }),
    {
        setOverlayPartnerVisible
    },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Donation) return true;
            return next === prev;
        }
    }
)(DonationSuccess);
